// extracted by mini-css-extract-plugin
export default {"emptyMatchStatistic__container":"styles_emptyMatchStatistic__container__geyWR","emptyMatchStatistic__text":"styles_emptyMatchStatistic__text__jpuiN"};